import { render, staticRenderFns } from "./TikTokRedirect.vue?vue&type=template&id=29253eed&scoped=true&"
import script from "./TikTokRedirect.vue?vue&type=script&lang=js&"
export * from "./TikTokRedirect.vue?vue&type=script&lang=js&"
import style0 from "./TikTokRedirect.vue?vue&type=style&index=0&id=29253eed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29253eed",
  null
  
)

export default component.exports